// extracted by mini-css-extract-plugin
export default {"wrapping-container":"WrappingContainer_wrapping-container__Eh7CO"};